import React from 'react';
import axios from "axios";
import { useState } from "react";
import APIUtils from '../utils/api_util';
import './login.css';

const Login = () => {
    const [usuario, setUsuario] = useState("");
    const [senha, setSenha] = useState("");

    const handleLogin = async () => {
        try {
            const url = `${APIUtils.API_URL}/api/v1/login`;
            const config = {
                headers: { 'Content-type': 'application/json' },
                timeout: 8000
            };
            await axios.post(url, JSON.stringify({ usuario, senha }), config);

            const token = Buffer.from(`${usuario}:${senha}`, 'utf8').toString('base64');
            localStorage.setItem("accessToken", token);
            window.location.href = '/';
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="login-title">Login</h2>

                <input
                    type="text"
                    placeholder="Usuário"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    className="login-input"
                />

                <input
                    type="password"
                    placeholder="Senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    className="login-input"
                />

                <button disabled={!usuario || !senha} onClick={handleLogin} className="login-button">
                    Entrar
                </button>
            </div>
        </div>
    );
};

export default Login;
